import { Button, Menu } from 'antd';
import { useState } from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';
import LinkOutlinedIcon from '@mui/icons-material/LinkOutlined';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import { useMediaQuery } from 'react-responsive'
import Adminhome from '../../AdminPages/Adminhome';
import Exuserdetails from '../../AdminPages/exuserdetails';
import Upload from '../../AdminPages/Upload';
import Links from '../../AdminPages/Links';
import Sloader from '../Loader/Sloader';
import { IconPencilUp } from '@tabler/icons-react';
import AddLegalUpdate from './Legalupdates';

const AdminNavbar = ({ IsServerWake }) => {

    const items = [
        {
            key: '1',
            icon: <HomeOutlinedIcon />,
            label: 'Home',

        },
        {
            key: '2',
            icon: <PersonOutlinedIcon />,
            label: 'Exisiting user details',

        },
        {
            key: '3',
            icon: <LinkOutlinedIcon />,
            label: 'VC & Fir links',
        },
        {
            key: '4',
            icon: <FileUploadOutlinedIcon />,
            label: 'Upload (Draft & Calender)',
        },
        {
            key: '5',
            icon: <IconPencilUp size={15} />,
            label: 'Legal Updates',
        },
    ]

    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 768px)' })
    // console.log(isTabletOrMobile);
    const [collapsed, setCollapsed] = useState(false);
    const [selectedKey, setSelectedKey] = useState("1"); // Default selected key

    const toggleCollapsed = () => {
        setCollapsed(!collapsed);
    };

    const renderSelectedItem = (key) => {
        switch (key) {
            case "1":
                return <Adminhome />
            case "2":
                return <Exuserdetails />
            case "3":
                return <Links />
            case "4":
                return <Upload />
            case "5":
                return <AddLegalUpdate />
            default:
                return <div>Select an option</div>;
        }
    }

    return (
        <>
            <div style={{ display: isTabletOrMobile === true ? "block" : "flex" }}>
                <div>
                    <Button
                        type="secondary"
                        onClick={toggleCollapsed}
                        style={{
                            marginBottom: 16,
                        }}
                    >
                        {collapsed ? <MenuIcon /> : <MenuOpenIcon />}
                    </Button>
                    <Menu
                        defaultSelectedKeys={['1']}
                        defaultOpenKeys={['sub1']}
                        mode={isTabletOrMobile === true ? "horizontal" : "inline"}
                        inlineCollapsed={collapsed}
                        items={items}
                        onSelect={(e) => setSelectedKey(e.key)} // Update selected key
                    />
                </div>

                {/* Page Content */}
                <div style={{ padding: "20px", flex: 1 }}>
                    {
                        IsServerWake === false ? <Sloader /> : renderSelectedItem(selectedKey)
                        // renderSelectedItem(selectedKey)
                    }

                </div>
            </div>

        </>
    )
}

export default AdminNavbar